import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M5 3v16h16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m5 19 6-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m2 6 3-3 3 3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m18 16 3 3-3 3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Move3d";
const Move3d = memo(themed(Icon));
export {
  Move3d
};
//# sourceMappingURL=move-3d.js.map
